import { generateUID } from '../../../../shared/utils';
import { FormInputsModel } from '../models/FormsInput.model';
import {
  BuilderInputType,
  FormInputsDTO,
  FormInputsRequestDTO,
} from '../types';

export class FormInputUtil {
  public static mapToViewModel(dto: FormInputsDTO): FormInputsModel {
    return {
      id: dto.id,
      label: dto.label,
      type: dto.type,
      palceholder: dto.placeholder,
      description: dto.description,
      values: dto.values,
      isRequired: dto.isRequired,
    };
  }

  public static toRequestDTO(
    inputModel?: FormInputsModel,
    type?: BuilderInputType,
  ): FormInputsRequestDTO {
    return {
      id: inputModel ? inputModel.id : generateUID(),
      type: inputModel ? inputModel.type : type ? type : undefined,
      placeholder: inputModel ? inputModel.palceholder : undefined,
      label: inputModel ? inputModel.label : '',
      description: inputModel ? inputModel.description : undefined,
      values: inputModel ? inputModel.values : undefined,
      isRequired: inputModel ? inputModel.isRequired : false,
    };
  }
}
